(() => {
  const root = document.querySelector('.tgb-ux-hero');
  if (!root || root.dataset.uxEventsReady === 'true') return;
  root.dataset.uxEventsReady = 'true';
  const shopify = window.Shopify;
  const isPreview = root.dataset.themeRole !== 'main' || shopify?.designMode;
  if (!isPreview && !shopify?.customerPrivacy && typeof shopify?.loadFeatures === 'function') {
    shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[data-tgb-ux]');
    if (!link) return;
    // Explicitly handle the finder jump, including a repeated click on the same hash.
    if (link.dataset.tgbUx === 'hero_gift_finder') {
      const finder = document.querySelector('#gift-finder');
      if (finder) {
        event.preventDefault();
        event.stopPropagation();
        finder.scrollIntoView({ block: 'start', behavior: 'instant' });
        const heading = finder.querySelector('h2');
        if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
        history.replaceState(null, '', '#gift-finder');
      }
    }
    // The draft and theme editor never send production analytics.
    if (isPreview) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
    const destination = new URL(link.href, window.location.href);
    const parameters = {
      ux_action: link.dataset.tgbUx,
      ux_label: link.textContent.trim().replace(/\s+/g, ' ').slice(0, 100),
      ux_destination: destination.pathname + destination.hash,
      transport_type: 'beacon'
    };
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'tgb_homepage_click', parameters);
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: 'tgb_homepage_click', ...parameters });
    }
  }, true);
})();

(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-tgb-review-carousel]').forEach((carousel) => {
      if (carousel.dataset.reviewReady === 'true') return;
      const rail = carousel.querySelector('.tgb-ux-review-rail');
      const previous = carousel.querySelector('[data-tgb-review-prev]');
      const next = carousel.querySelector('[data-tgb-review-next]');
      const controls = carousel.querySelector('.tgb-ux-review-controls');
      if (!rail || !previous || !next || !controls) return;
      carousel.dataset.reviewReady = 'true';
      const update = () => {
        const maximum = rail.scrollWidth - rail.clientWidth;
        previous.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= maximum - 2;
        controls.hidden = maximum <= 2;
      };
      const move = (direction) => {
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        rail.scrollBy({left: direction * (rail.clientWidth + gap), behavior: reduceMotion ? 'auto' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(rail);
      update();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
